import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Drawer,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputBase,
  Paper,
  Stack,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import close from "../assets/svg/drawer_close.svg";
import arrow from "../assets/svg/backspace.svg";
import speaker from "../assets/svg/speaker.svg";
import volumn_on from "../assets/svg/volume_on.svg";
import volumn_off from "../assets/svg/volume_off.svg";
import send from "../assets/svg/send.svg";
import postpalLogo from "../assets/svg/logo_blue.svg";
import SimpleBar from "simplebar-react";
import { useEffect } from "react";
import {
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db, storage } from "../firebaseConfig";
import { toast } from "react-toastify";
import InspectionFormReportPDF from "./InspectionFormReportPDF";
import ConditionFormReportPDF from "./ConditionFormReportPDF";
import MeasurementFormReportPDF from "./MeasurementFormReportPDF";
import { getAddons, getFormDetails, getItem, updateItemDetails } from "../helper/functions";
import { uploadDocuments } from "../helper";
import { getDownloadURL, ref, uploadBytes, uploadBytesResumable } from "firebase/storage";
import { IoMdCloseCircleOutline } from "react-icons/io";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function TableItemAddOns({
  data,
  open,
  onClose,
  packageActiveData,
  userActiveData,
  packageCollection,
  shipmentCollection,
}) {
  const [expanded, setExpanded] = useState("");
  const [expandedTwo, setExpandedTwo] = useState("");
  const [allAddons, setAllAddons] = useState([]);
  const [packageAddOnsData, setPackageAddOnsData] = useState([]);
  const [shipmentAddOnsData, setShipmentAddOnsData] = useState([]);

  const [acceptedAddons, setAcceptedAddons] = useState([]);
  const [acceptedPackageAddons, setAcceptedPackageAddons] = useState([]);
  const [acceptedShipmentAddons, setAcceptedShipmentAddons] = useState([]);
  const [formDetails, setFormDetails] = useState({});

  console.log(data, "data in add-ons");

  useEffect(() => {
    const fetchAddOnsData = async () => {
      console.log(data?.addons, "data?.addons");

      if (data?.addons?.length > 0) {
        const addOns = await getAddons([{
          key: "__name__",
          operator: "in",
          value: data?.addons,
        }]);
        console.log(data, "addOns in useeffect")
        // const filteredAddOns = addOns.filter((addon) => addon !== null);
        setAllAddons(addOns);
        const item = await getItem(data.itemId)
        console.log(item, "item in useeffect");

        const acceptedAddons = item.acceptedAddons || [];

        setAcceptedAddons(acceptedAddons);
      } else {
        setAllAddons([]);
        setAcceptedAddons([]);
      }
    };

    fetchAddOnsData();
  }, [data?.itemId]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleChangeTwo = (panel) => (event, newExpanded) => {
    setExpandedTwo(newExpanded ? panel : false);
  };

  const handleCloseDrawer = () => {
    setExpanded("");
    onClose();
  };

  const handleCheckboxChange = (event, addonName) => {
    const { checked } = event.target;

    const addonDetails = allAddons.find(addon => addon.title === addonName);
    console.log(addonDetails, addonName, allAddons, "allAddonsallAddons");

    if (acceptedAddons.find(addon => addon.title === addonDetails.title)) {
      const updatedAcceptedAddon = acceptedAddons.map((addon) => addon.title === addonDetails.title ? { ...addon, isCompleted: checked } : addon);
      setAcceptedAddons(updatedAcceptedAddon);
    }
    else {
      setAcceptedAddons(prev => ([...prev, {
        title: addonDetails.title,
        isCompleted: checked,
        docs: [],
        id: addonDetails.id
      }]));
    }

  };
  const handleUploadDoc = async (addonName, files) => {
    const urls = await uploadDocuments(files);
    const addonDetails = allAddons.find(addon => addon.title === addonName);
    if (acceptedAddons.find(addon => addon.title === addonDetails.title)) {
      const updatedAcceptedAddon = acceptedAddons.map((addon) => addon.title === addonDetails.title ? { ...addon, docs: urls } : addon);
      setAcceptedAddons(updatedAcceptedAddon);
      updateItemDetails(data?.itemId, {
        acceptedAddons: updatedAcceptedAddon
      }).then(res => {
        toast.success("Document Uploaded Successfully")
      })
    }
    else {
      setAcceptedAddons(prev => ([...prev, {
        title: addonDetails.title,
        isCompleted: false,
        docs: urls,
        id: addonDetails.id
      }]));
      updateItemDetails(data?.itemId, {
        acceptedAddons: [...acceptedAddons, {
          title: addonDetails.title,
          isCompleted: false,
          docs: urls,
          id: addonDetails.id
        }]
      }).then(res => {
        toast.success("Document Uploaded Successfully")
      })
    }
  }

  const handleSubmitItemAddons = async () => {
    updateItemDetails(data?.itemId, {
      acceptedAddons: acceptedAddons
    }).then(item => {
      toast.success('Addons Updated Successfully !')
    })
  };

  const handleSubmitPackageAddons = async () => {

  };

  const handleSubmitShipmentAddons = async () => {

  };

  const handleAllForm = (formType, packageActiveData, data) => {
    console.log(formType);
    window.open(
      `/${formType}?id=${packageActiveData?.id}&itemId=${data?.itemId}`,
      "_blank"
    );
  };
  const formDetailsFn = async () => {
    const form = await getFormDetails(data?.itemId);
    console.log(form, "foemDetauk");

    setFormDetails(form);
  }

  useEffect(() => {
    if (data?.itemId) {
      formDetailsFn();
    }
  }, [data?.itemId]);

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{ sx: { background: "rgba(0, 0, 0, 0.5)" } }}
    >
      <Box sx={{ width: "1040px", display: "flex" }}>
        <Box>
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "572px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{ cursor: "pointer", marginRight: "20px" }}
                onClick={() => {
                  handleCloseDrawer();
                }}
              >
                <img
                  src={arrow}
                  alt="back_arrow"
                  style={{ minHeight: "24px", minWidth: "24px" }}
                />
              </Box>
              <Box sx={{ cursor: "pointer", marginRight: "20px" }}>
                {data?.item_img ? (
                  <img
                    src={data?.item_img}
                    alt="item_image"
                    width="40px"
                    height="40px"
                  />
                ) : (
                  <img
                    src={postpalLogo}
                    alt="postpalLogo"
                    width="40px"
                    height="40px"
                  />
                )}
              </Box>
              <Typography variant="h5" component="h5">
                <Tooltip title={`${data?.fullName}'s Add-ons`} arrow placement="bottom">
                  {`${data?.fullName}'s Add-ons`.split(' ').slice(0, 3).join(' ') + "..."}
                </Tooltip>
              </Typography>
            </Box>
            <Box
              sx={{ paddingRight: "20px", cursor: "pointer" }}
              onClick={handleCloseDrawer}
            >
              <img src={close} alt="close" />
            </Box>
          </Box>
          <SimpleBar
            forceVisible="y"
            autoHide={true}
            style={{ maxHeight: "90vh" }}
            className="custom-scrollbar"
          >
            <Box>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
                sx={{ width: 572 }}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <label
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Items Add-ons ({allAddons.filter(addon => addon.addOnType === "ITEM").length})
                  </label>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    {allAddons?.find(addon => addon.title === "Check Functionality" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px 5px"
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={acceptedAddons.find(addon => addon.title === "Check Functionality")?.isCompleted || false}
                            name="checkfunctionality"
                            onChange={(event) => handleCheckboxChange(event, "Check Functionality")}
                          />
                        }
                        label="Inspection Form"
                      />
                      <Box>
                        <Button
                          // variant="contained"
                          color="primary"
                          // disabled={formsId?.some(
                          //   (form) =>
                          //     form?.id === data?.itemId && form?.ConditionForm
                          // )}
                          onClick={() =>
                            handleAllForm(
                              "inspectionForm",
                              packageActiveData,
                              data
                            )
                          }
                        >{formDetails?.InspectionForm ? "Edit report" : 'Start report'}</Button>
                        {formDetails?.InspectionForm?.docUrl && <Button
                          // variant="contained"
                          color="primary"
                          // disabled={formsId?.some(
                          //   (form) =>
                          //     form?.id === data?.itemId && form?.ConditionForm
                          // )}
                          onClick={() => window.open(formDetails?.InspectionForm?.docUrl, "_blank")}
                        >View Report</Button>}
                      </Box>
                    </Box>
                    }
                    {allAddons?.find(addon => addon.title === "Check Condition" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px 5px"
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={acceptedAddons.find(addon => addon.title === "Check Condition")?.isCompleted || false}
                            name="checkcondition"
                            onChange={(event) => handleCheckboxChange(event, "Check Condition")}
                          />
                        }
                        label="Condition Form"
                      />
                      <Box>
                        <Button
                          // variant="contained"
                          color="primary"
                          // disabled={formsId?.some(
                          //   (form) =>
                          //     form?.id === data?.itemId && form?.ConditionForm
                          // )}
                          onClick={() =>
                            handleAllForm(
                              "conditionForm",
                              packageActiveData,
                              data
                            )
                          }
                        >{formDetails?.ConditionForm ? "Edit report" : 'Start report'}</Button>
                        {formDetails?.ConditionForm?.docUrl && <Button
                          // variant="contained"
                          color="primary"
                          // disabled={formsId?.some(
                          //   (form) =>
                          //     form?.id === data?.itemId && form?.ConditionForm
                          // )}
                          onClick={() => window.open(formDetails?.ConditionForm?.docUrl, "_blank")}
                        >View Report</Button>}
                      </Box>
                    </Box>}
                    {allAddons?.find(addon => addon.title === "Check Measurement" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px 5px"
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={acceptedAddons.find(addon => addon.title === "Check Measurement")?.isCompleted || false}
                            name="checkmeasurement"
                            onChange={(event) => handleCheckboxChange(event, "Check Measurement")}
                          />
                        }
                        label="Measurement Form"
                      />
                      <Button
                        // variant="contained"
                        color="primary"
                        // disabled={formsId?.some(
                        //   (form) =>
                        //     form?.id === data?.itemId && form?.ConditionForm
                        // )}
                        onClick={() =>
                          handleAllForm(
                            "conditionForm",
                            packageActiveData,
                            data
                          )
                        }
                      >Start report</Button>
                    </Box>}
                    {allAddons?.find(addon => addon.title === "Remove Shoe Box" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={acceptedAddons.find(addon => addon.title === "Remove Shoe Box")?.isCompleted || false}
                            onChange={(event) => handleCheckboxChange(event, "Remove Shoe Box")}
                          />
                        }
                        label="Remove Shoes Box"
                      />
                    </Box>}
                    {allAddons?.find(addon => addon.title === "Extended Warranty" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={acceptedAddons.find(addon => addon.title === "Extended Warranty")?.isCompleted || false}
                            onChange={(event) => handleCheckboxChange(event, "Extended Warranty")}
                          />
                        }
                        label="Extended Warranty"
                      />
                    </Box>}
                    {allAddons?.find(addon => addon.title === "More Photos" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                      }}
                    >
                      <Box sx={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={acceptedAddons.find(addon => addon.title === "More Photos")?.isCompleted || false}
                              onChange={(event) => handleCheckboxChange(event, "More Photos")}
                            />
                          }
                          label="More Photos"
                        />
                        <input type="file" onChange={async (e) => handleUploadDoc('More Photos', [...e.target.files])} multiple />
                      </Box>
                      <Box
                        display="flex"
                        flexWrap="wrap"
                        sx={{
                          gap: "16px",
                          background: "white",
                          // minHeight: "100px",
                          // minWidth: "100px",
                          width: "fit-content",
                          padding: "16px",
                          borderRadius: "4px",
                          mt: 1,
                        }}
                      >
                        {acceptedAddons?.find(addon => addon.title === "More Photos")?.docs?.map((photo, index) => (
                          <Box key={index} position="relative">
                            <img
                              src={photo}
                              alt={`Package ${index}`}
                              style={{
                                height: "auto",
                                width: "75px",
                                // objectFit: "cover",
                              }}
                            />
                            <IconButton
                              size="small"
                              color="error"
                              sx={{ position: "absolute", top: 0, right: 0 }}
                              onClick={() => { }}
                            >
                              <IoMdCloseCircleOutline fontSize="small" />
                            </IconButton>
                          </Box>
                        ))}
                      </Box>
                    </Box>}
                    {allAddons?.find(addon => addon.title === "Luxury Authentication" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={acceptedAddons.find(addon => addon.title === "Luxury Authentication")?.isCompleted || false}
                              onChange={(event) => handleCheckboxChange(event, "Luxury Authentication")}
                            />
                          }
                          label="Luxury Authentication"
                        />
                        <input type="file" onChange={async (e) => handleUploadDoc('Luxury Authentication', [...e.target.files])} />
                      </Box>
                      {acceptedAddons?.find(addon => addon.title === "Luxury Authentication")?.docs?.length > 0 && <span>{`${acceptedAddons?.find(addon => addon.title === "Luxury Authentication").docs?.length} Files Uploaded`}</span>}
                    </Box>}
                    {allAddons?.find(addon => addon.title === "Sneakers Authentication" && addon.addOnType === "ITEM") && <Box
                      sx={{
                        backgroundColor: "#FAFAFA",
                        paddingX: "10px",
                        border: "1px solid #E5E5E8",
                        borderRadius: "4px",
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={acceptedAddons.find(addon => addon.title === "Sneakers Authentication")?.isCompleted || false}
                              onChange={(event) => handleCheckboxChange(event, "Sneakers Authentication")}
                            />
                          }
                          label="Sneakers Authentication"
                        />
                        <input type="file" onChange={async (e) => handleUploadDoc('Sneakers Authentication', [...e.target.files])} />
                      </Box>
                      {acceptedAddons?.find(addon => addon.title === "Sneakers Authentication")?.docs?.length > 0 && <span>{`${acceptedAddons?.find(addon => addon.title === "Luxury Authentication").docs?.length} Files Uploaded`}</span>}
                    </Box>}


                  </Box>
                  <Box>
                    <Stack direction="column" spacing={"10px"}>
                      {allAddons?.filter(addon => addon.addOnType === "ITEM")?.length > 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitItemAddons}
                          >
                            Submit
                          </Button>
                        </Box>
                      )}
                    </Stack>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
                sx={{ width: 572 }}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <label
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Package Add-ons ({packageAddOnsData?.length})
                  </label>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    <Stack direction="column" spacing={"10px"}>
                      {packageAddOnsData?.length > 0 &&
                        packageAddOnsData?.map((addOn) => (
                          <Box
                            key={addOn?.id}
                            sx={{
                              backgroundColor: "#FAFAFA",
                              paddingX: "10px",
                              border: "1px solid #E5E5E8",
                              borderRadius: "4px",
                            }}
                          >
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={acceptedPackageAddons?.some(
                                      (item) => item.id === addOn.id
                                    )}
                                    onChange={(event) =>
                                      handleCheckboxChange(
                                        event,
                                        addOn,
                                        "package"
                                      )
                                    }
                                  />
                                }
                                label={addOn?.title}
                              />
                            </FormGroup>
                          </Box>
                        ))}
                      {packageAddOnsData?.length > 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmitPackageAddons}
                          >
                            Submit
                          </Button>
                        </Box>
                      )}
                    </Stack>
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
                sx={{ width: 572 }}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <label
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Shipment Add-ons ({shipmentAddOnsData?.length})
                  </label>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack direction="column" spacing={"10px"}>
                    {shipmentAddOnsData?.length > 0 &&
                      shipmentAddOnsData?.map((addOn) => (
                        <Box
                          key={addOn?.id}
                          sx={{
                            backgroundColor: "#FAFAFA",
                            paddingX: "10px",
                            border: "1px solid #E5E5E8",
                            borderRadius: "4px",
                          }}
                        >
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={acceptedShipmentAddons?.some(
                                    (item) => item.id === addOn.id
                                  )}
                                  onChange={(event) =>
                                    handleCheckboxChange(
                                      event,
                                      addOn,
                                      "shipment"
                                    )
                                  }
                                />
                              }
                              label={addOn?.title}
                            />
                          </FormGroup>
                        </Box>
                      ))}
                    {shipmentAddOnsData?.length > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSubmitShipmentAddons}
                        >
                          Submit
                        </Button>
                      </Box>
                    )}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            </Box>
          </SimpleBar>
        </Box>
        <Box sx={{ backgroundColor: "#FAFAFA" }}>
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingLeft: "20px",
              paddingTop: "20px",
              paddingBottom: "13px",
              display: "flex",
              justifyContent: "space-between",
              width: "462px",
              backgroundColor: "#FAFAFA",
            }}
          >
            <Typography variant="h5" component="h5">
              Shipping Guider
            </Typography>
            <Box
              sx={{
                paddingX: "10px",
                paddingY: "3px",
                cursor: "pointer",
                display: "flex",
                border: "1px solid #5E17EB",
                borderRadius: "8px",
                backgroundColor: "#F3EDFF",
              }}
            >
              <img src={speaker} alt="speaker_icon" />
              <label style={{ marginLeft: "10px" }}>speaker mode</label>
            </Box>
          </Box>
          <Box sx={{ height: "84vh" }}>
            <Accordion
              expanded={expandedTwo === "panel1"}
              onChange={handleChangeTwo("panel1")}
              sx={{ width: 462 }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  Packaging Guider
                </label>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#FAFAFA",
                      paddingX: "10px",
                      border: "1px solid #E5E5E8",
                      marginTop: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Lorem ipsum dolor sit amet"
                      />
                    </FormGroup>
                    <img src={volumn_on} alt="volumn_on" />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#FAFAFA",
                      paddingX: "10px",
                      border: "1px solid #E5E5E8",
                      marginTop: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Lorem ipsum dolor sit amet"
                      />
                    </FormGroup>
                    <img src={volumn_on} alt="volumn_on" />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#FAFAFA",
                      paddingX: "10px",
                      border: "1px solid #E5E5E8",
                      marginTop: "10px",
                      borderRadius: "4px",
                      paddingBottom: "20px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Lorem ipsum dolor sit amet"
                      />
                    </FormGroup>
                    <img src={volumn_off} alt="volumn_on" />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedTwo === "panel2"}
              onChange={handleChangeTwo("panel2")}
              sx={{ width: 462 }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  General Shipping Procedure
                </label>
              </AccordionSummary>
              <AccordionDetails>
                <Box></Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expandedTwo === "panel3"}
              onChange={handleChangeTwo("panel3")}
              sx={{ width: 462 }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  Warning and Directives
                </label>
              </AccordionSummary>
              <AccordionDetails>
                <Box></Box>
              </AccordionDetails>
            </Accordion>
          </Box>
          <Box
            sx={{
              paddingLeft: "24px",
              marginTop: "20px",
              marginRight: "40px",
            }}
          >
            <Box>
              <Paper
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #E5E5E8",
                  width: 350,
                  height: 40,
                  marginTop: "10px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search... "
                  inputProps={{ "aria-label": "Ask me a question" }}
                  size="small"
                />
                <img src={send} alt="send" />
              </Paper>
            </Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}

export default TableItemAddOns;
